/* eslint-disable require-unicode-regexp */
/** @jsx jsx **/
import { Box, Flex, Text, jsx } from 'theme-ui'
import { FC } from 'react'
import { Close } from '~/components/icons/close'

const FILTER_SCHEMA = {
  inStock: {
    name: 'inStock',
    label: 'In Stock',
    items: [{ value: true, name: 'Yes' }],
    type: 'boolean',
    field: 'default',
  },
  ProductType: {
    name: 'productType',
    label: 'Product Type',
    items: [],
    type: 'checkbox',
    field: 'default',
  },
  'Product Related': {
    name: 'relatedProductsType',
    label: 'Product Type',
    items: [],
    type: 'checkbox',
    field: 'metafield',
    valueSeparator: ' - ',
  },
  filterCategory: {
    name: 'filterCategory',
    label: 'Category',
    items: [],
    type: 'checkbox',
    field: 'metafield',
  },
  'New Arrivals': {
    name: 'collectionType',
    label: 'Category',
    items: [],
    type: 'checkbox',
    field: 'specific',
  },
}

type Props = {
  onClick: (
    changeItem: {
      name: string
      value: string
    },
    categoryName: string
  ) => void
  value: { name: string; value: string; label: string; categoryName: string }
}

function capitalizeAndSplit(inputString: string) {
  const capitalized = inputString.charAt(0).toUpperCase() + inputString.slice(1)

  const result = capitalized.replace(/([A-Z])/g, ' $1')

  return result.replace('Collection', 'Product')
}

const extractLabel = (label: string) => {
  const colorRegex = /color/i
  const sizeRegex = /size/i

  const filterFromSchema = Object.keys(FILTER_SCHEMA).find(
    filter => FILTER_SCHEMA[filter].name === label
  )

  if (filterFromSchema) {
    return FILTER_SCHEMA[filterFromSchema].label
  }

  if (colorRegex.test(label.toLowerCase())) {
    return 'Color'
  } else if (sizeRegex.test(label)) {
    return 'Size'
  } else if (label === 'collectionType') {
    return 'Category'
  }

  return capitalizeAndSplit(label)
}

const FilterBadge: FC<Props> = ({ value, onClick }) => {
  return (
    <Flex
      sx={{
        bg: '#F3F3F3',
        whiteSpace: 'nowrap',
        alignItems: 'center',
        padding: '12px',
        gap: '4px',
      }}
    >
      <Text
        sx={{
          color: '#808080',
          backgroundColor: 'transparent',
          fontWeight: 400,
          fontSize: '13px',
          lineHeight: '19.9px',
          cursor: 'pointer',
          letterSpacing: '0.5px',
          textTransform: 'uppercase',
        }}
      >
        {(extractLabel(value.label) || value.label) +
          `${typeof value.name === 'string' ? ': ' : ''}`}
      </Text>
      {typeof value.name === 'string' && (
        <Box
          as="span"
          sx={{
            color: '#041826',
            fontWeight: 400,
            fontSize: '13px',
            lineHeight: '19.9px',
            letterSpacing: '0.5px',
            textTransform: 'capitalize',
          }}
        >
          {value.name.toLowerCase()}
        </Box>
      )}
      <button
        onClick={() => {
          onClick(
            {
              name: value.name,
              value: value.value,
            },
            value.categoryName
          )
        }}
        type="button"
        sx={{
          variant: 'buttons.noStyle',
          height: '100%',
          pl: '8px',
          position: 'relative',
          top: '-10px',
          right: '-5px',
          svg: {
            fill: '#808080',
          },
        }}
      >
        <Close />
      </button>
    </Flex>
  )
}

export default FilterBadge
